import * as types from './mutations-type'

const mutations = {
  [types.SET_HEIHT] (state, data) {
    state.height = data
  },
  [types.SET_PRINTLABELS] (state, data) {
    state.printLabels = data
  },
  [types.SET_ORDERLIST] (state, data) {
    state.orderList = data
  },
  [types.SET_ORDERINFO] (state, data) {
    state.orderInfo = data
  },
  [types.SET_LANGUAGE] (state, language) {
    state.language = language
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js